import { render } from "./RadioPage.vue?vue&type=template&id=c8547dd0"
import script from "./RadioPage.vue?vue&type=script&lang=js"
export * from "./RadioPage.vue?vue&type=script&lang=js"

import "./RadioPage.vue?vue&type=style&index=0&id=c8547dd0&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__